import React from 'react'

import style from '@styles/form/SubmitButton.module.scss'

interface Props {
  text: string
}

const SubmitButton = ({ text }: Props) => (
  <input className={style.button} type="submit" value={text} />
)

export { SubmitButton }
